import { create } from 'zustand';

interface RewardInfo {
  amount: string;
  currency?: string;
}

interface RewardAnimationStore {
  isAnimationVisible: boolean;
  rewardInfo: RewardInfo | null;
  showAnimation: (rewardInfo: RewardInfo) => void;
  hideAnimation: () => void;
}

export const useRewardAnimation = create<RewardAnimationStore>((set) => ({
  isAnimationVisible: false,
  rewardInfo: null,
  showAnimation: (rewardInfo: RewardInfo) =>
    set({ isAnimationVisible: true, rewardInfo }),
  hideAnimation: () => set({ isAnimationVisible: false, rewardInfo: null }),
}));
